import React from "react";

import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  InputGroup,

  FormInput,
  DatePicker,
  Row,
  Col
} from "shards-react";

const SidebarCategories = props => {
  const { date, setDate, press, setPress, regDate, setRegDate } = props;
  const onChange = e => {
    const {
      target: { value }
    } = e;
    setPress(value);
  }

  const dateChange = (e) => {
    let tmp = new Date(e)
    const year = tmp.getFullYear();
    const month = tmp.getMonth() + 1;
    const day = tmp.getDate();
    tmp = `${year}-${month}-${day}`
    console.log(tmp)
    setDate(tmp)
    console.log(date)
  }
  return (
    <Card small className="mb-3">
      <CardHeader className="border-bottom">
        {/* <h6 className="m-0">{title}</h6> */}
        <h6 className="m-0 text-muted d-block">보도 정보</h6>
      </CardHeader>
      <CardBody className="p-0">
        <ListGroup flush>
          <ListGroupItem className="px-3 pb-2">
            <strong className="text-muted d-block mb-2">언론사 정보</strong>
            <InputGroup className="mb-3">
              <FormInput
                placeholder="언론사 정보를 입력해주세요"
                onChange={onChange}
                value={press}
                name='source'
              />
            </InputGroup>
            <Row>
              <Col>
                <strong className="text-muted d-block mb-2">보도일자</strong>
                <InputGroup className="mb-3" md="6">
                  <DatePicker
                    size="md"
                    selected={date}
                    onChange={setDate}
                    placeholdeText="날짜를 입력하세요"
                    dropdownMode="select"
                    className="text-center col-md-12"
                    name="date"
                  />
                </InputGroup>
              </Col>
              <Col>
                <strong className="text-muted d-block mb-2">게시일자</strong>
                <InputGroup className="mb-3" md="6">
                  <DatePicker
                    size="md"
                    selected={regDate}
                    onChange={setRegDate}
                    placeholdeText="날짜를 입력하세요"
                    dropdownMode="select"
                    className="text-center col-md-12"
                    name="regDate"
                  />
                </InputGroup>
              </Col>
            </Row>
          </ListGroupItem>
        </ListGroup>
      </CardBody>
    </Card>
  );
};

export default SidebarCategories;
